import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useWalletValue } from '@frontend/hooks/useWalletValue';
import { useCoinPriceContext } from '@frontend/providers/CoinPriceProvider';
import { JDI_TOKEN, proPlans } from '@jdiyield/constants'; // import { balanceOf, checkProActivate } from '@jdiyield/contracts'

import { useWeb3React } from '@web3-react/core';
import * as React from 'react';
import { createContext, useContext } from 'react';
var initialState = {
  profiles: [],
  myJdi: 0,
  jdiPrice: 0,
  proActivated: false,
  packageId: -1,
  watchList: [],
  expiredTime: 0
};
var ConfigContext = /*#__PURE__*/createContext(initialState);

var saveConfig = function saveConfig(state) {
  localStorage.setItem('config', JSON.stringify(state));
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'ADD_WATCH_LIST':
      {
        var result = _objectSpread(_objectSpread({}, state), {}, {
          watchList: [].concat(_toConsumableArray(state.watchList), [action.payload.address.toLowerCase()])
        });

        saveConfig(result);
        return result;
      }

    case 'REMOVE_WATCH_LIST':
      {
        var _result = _objectSpread(_objectSpread({}, state), {}, {
          watchList: state.watchList.filter(function (address) {
            return address.toLowerCase() !== action.payload.address.toLowerCase();
          })
        });

        saveConfig(_result);
        return _result;
      }

    case 'ADD_PROFILE':
      {
        var profileID = state.profiles.length;

        var _result2 = _objectSpread(_objectSpread({}, state), {}, {
          profiles: [].concat(_toConsumableArray(state.profiles), [{
            profileID: profileID,
            name: action.payload.name,
            wallets: []
          }])
        });

        saveConfig(_result2);
        return _result2;
      }

    case 'REMOVE_PROFILE':
      {
        var _result3 = _objectSpread(_objectSpread({}, state), {}, {
          profiles: state.profiles.filter(function (_ref) {
            var profileID = _ref.profileID;
            return profileID !== action.payload.profileID;
          })
        });

        saveConfig(_result3);
        return _result3;
      }

    case 'EDIT_PROFILE':
      {
        var _result4 = _objectSpread(_objectSpread({}, state), {}, {
          profiles: state.profiles.map(function (profile) {
            if (profile.profileID === action.payload.profileID) return _objectSpread(_objectSpread({}, profile), {}, {
              name: action.payload.name
            });
            return profile;
          })
        });

        saveConfig(_result4);
        return _result4;
      }

    case 'ADD_WALLET':
      {
        var newProfiles = state.profiles.map(function (profile) {
          if (profile.profileID === action.payload.profileID) {
            var _action$payload = action.payload,
                chainID = _action$payload.chainID,
                address = _action$payload.address;
            var walletID = profile.wallets.length;
            return _objectSpread(_objectSpread({}, profile), {}, {
              wallets: [].concat(_toConsumableArray(profile.wallets), [{
                walletID: walletID,
                chainID: chainID,
                address: address
              }])
            });
          }

          return profile;
        });

        var _result5 = _objectSpread(_objectSpread({}, state), {}, {
          profiles: newProfiles
        });

        saveConfig(_result5);
        return _result5;
      }

    case 'REMOVE_WALLET':
      {
        var _newProfiles = state.profiles.map(function (profile) {
          if (profile.profileID === action.payload.profileID) return _objectSpread(_objectSpread({}, profile), {}, {
            wallets: profile.wallets.filter(function (_ref2) {
              var walletID = _ref2.walletID;
              return walletID !== action.payload.walletID;
            })
          });
          return profile;
        });

        var _result6 = _objectSpread(_objectSpread({}, state), {}, {
          profiles: _newProfiles
        });

        saveConfig(_result6);
        return _result6;
      }

    case 'SET_EXCLUDES_PLATFORM':
      {
        var _newProfiles2 = state.profiles.map(function (profile) {
          if (profile.profileID === action.payload.profileID) {
            var wallets = profile.wallets.map(function (wallet) {
              if (wallet.walletID === action.payload.walletID) {
                return _objectSpread(_objectSpread({}, wallet), {}, {
                  excludes: action.payload.excludes
                });
              }

              return wallet;
            });
            return _objectSpread(_objectSpread({}, profile), {}, {
              wallets: wallets
            });
          }

          return profile;
        });

        var _result7 = _objectSpread(_objectSpread({}, state), {}, {
          profiles: _newProfiles2
        });

        saveConfig(_result7);
        return _result7;
      }

    case 'PERSIST':
      return _objectSpread(_objectSpread({}, state), action.payload);

    default:
      return state;
  }
};

export var WalletConfigProvider = function WalletConfigProvider(_ref3) {
  var children = _ref3.children;

  var _React$useReducer = React.useReducer(reducer, initialState),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  React.useEffect(function () {
    var config = localStorage.getItem('config');
    dispatch({
      type: 'PERSIST',
      payload: JSON.parse(config)
    });
  }, []);

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var _useCoinPriceContext = useCoinPriceContext(),
      coinList = _useCoinPriceContext.coinList;

  var _useWalletValue = useWalletValue({
    jdiPrice: 0,
    myJdi: 0,
    proActivated: false,
    packageId: -1,
    expiredTime: 0
  }, /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(setValue) {
      var ratePrice, _coinList$JDI_TOKEN, _yield$import, balanceOf, checkProActivate, balance, _yield$checkProActiva, isActivated, _packageId, _expiredTime, _myJdi;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ratePrice = 0;

              if (coinList[JDI_TOKEN]) {
                ratePrice = (_coinList$JDI_TOKEN = coinList[JDI_TOKEN]) === null || _coinList$JDI_TOKEN === void 0 ? void 0 : _coinList$JDI_TOKEN.usd;
              }

              setValue({
                jdiPrice: ratePrice,
                myJdi: 0,
                proActivated: false,
                packageId: -1
              });

              if (!account) {
                _context.next = 25;
                break;
              }

              _context.next = 6;
              return import('@jdiyield/contracts');

            case 6:
              _yield$import = _context.sent;
              balanceOf = _yield$import.balanceOf;
              checkProActivate = _yield$import.checkProActivate;

              if (!account) {
                _context.next = 15;
                break;
              }

              _context.next = 12;
              return balanceOf(account, JDI_TOKEN, process.env.NEXT_PUBLIC_MAIN_CHAIN_ID || 56);

            case 12:
              _context.t0 = _context.sent;
              _context.next = 16;
              break;

            case 15:
              _context.t0 = 0;

            case 16:
              balance = _context.t0;
              _context.next = 19;
              return checkProActivate(account);

            case 19:
              _yield$checkProActiva = _context.sent;
              isActivated = _yield$checkProActiva.isActivated;
              _packageId = _yield$checkProActiva.packageId;
              _expiredTime = _yield$checkProActiva.expiredTime;
              _myJdi = +balance / 1e18;
              setValue({
                myJdi: _myJdi,
                jdiPrice: ratePrice,
                proActivated: isActivated || process.env.NEXT_PUBLIC_PRO_MODE === 'true',
                packageId: _packageId,
                expiredTime: _expiredTime
              });

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }(), [account, coinList]),
      _useWalletValue2 = _slicedToArray(_useWalletValue, 2),
      _useWalletValue2$ = _useWalletValue2[0],
      jdiPrice = _useWalletValue2$.jdiPrice,
      myJdi = _useWalletValue2$.myJdi,
      proActivated = _useWalletValue2$.proActivated,
      packageId = _useWalletValue2$.packageId,
      expiredTime = _useWalletValue2$.expiredTime,
      refetch = _useWalletValue2[1].refetch;

  var ctx = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, state), {}, {
      jdiPrice: jdiPrice,
      myJdi: myJdi,
      proActivated: proActivated,
      dispatch: dispatch,
      refetchRate: refetch,
      packageId: packageId,
      expiredTime: expiredTime,
      currentPlan: proPlans.find(function (_ref5) {
        var id = _ref5.id;
        return id === packageId;
      })
    });
  }, [expiredTime, jdiPrice, myJdi, packageId, proActivated, refetch, state]);
  return _jsx(ConfigContext.Provider, {
    value: ctx,
    children: children
  });
};
export var useWalletConfig = function useWalletConfig() {
  return useContext(ConfigContext);
};